module.exports = __webpack_public_path__ + "img/ring_g_skip_1_null@3x.fdf9ce20.png";